// Vendor Libs
import React from 'react';

// Components
import CatalogDetail from '../search-data/catalog-detail';
import CatalogItemsMissingEid from '../search-data/catalog-items-missing-eid';
import FreewheelAdRequest from '../search-data/mediaitem-freewheel-ad-request';
import FlexDashboard from '../core/flex-dashboard';
import MediaItemCIX from '../search-data/mediaitem-cix';
import IVIRequest from '../search-data/mediaitem-ivi-request';
import MediaItemDetail from '../search-data/mediaitem-detail';
import MediaItemFailures from '../search-data/mediaitem-failures';
import MediaItemJSON from '../search-data/mediaitem-json';
import MediaItemsEnhanced from '../search-data/media-items-enhanced';
import RadishDetail from '../search-data/radish-detail';

// Configs
import getDashboardConfig from '../../../config/flex-dashboard-config';

const dashboardConfig = {
    layout: {
        type: 'row',
        children: [
            {
                type: 'row',
                children: [
                    {
                        type: 'tabset',
                        children: [
                            {
                                id: 'MEDIAITEMDETAIL',
                                type: 'tab',
                                name: 'Media Item Detail',
                                component: MediaItemDetail,
                            },
                            {
                                type: 'tab',
                                name: 'Media Item Failures',
                                component: MediaItemFailures,
                            },
                        ],
                    },
                    {
                        type: 'tabset',
                        children: [
                            {
                                id: 'MEDIAITEMS',
                                type: 'tab',
                                name: 'Media Items',
                                component: MediaItemsEnhanced,
                                config: {
                                    componentProps: {
                                        detailLinkPrefix: '/investigation/enhanced-view',
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
            {
                type: 'row',
                children: [
                    {
                        type: 'tabset',
                        children: [
                            {
                                type: 'tab',
                                name: 'Farallon Media Item JSON',
                                component: MediaItemJSON,
                            },
                            {
                                type: 'tab',
                                name: 'Radish Web',
                                component: RadishDetail,
                            },
                            {
                                type: 'tab',
                                name: 'Radish Mobile',
                                component: RadishDetail,
                                config: {
                                    componentProps: {
                                        mobile: true,
                                    },
                                },
                            },
                            {
                                type: 'tab',
                                name: 'Catalog',
                                component: CatalogDetail,
                            },
                            {
                                type: 'tab',
                                name: 'Catalog Missing E*ID',
                                component: CatalogItemsMissingEid,
                            },
                            {
                                type: 'tab',
                                name: 'CIX',
                                component: MediaItemCIX,
                            },
                            {
                                type: 'tab',
                                name: 'IVI Request',
                                component: IVIRequest,
                            },
                            {
                                type: 'tab',
                                name: 'Freewheel Ad Request',
                                component: FreewheelAdRequest,
                            },
                        ],
                    },
                ],
                weight: 125,
            },
        ],
    },
};

function DashboardEnhancedView() {
    return (
        <FlexDashboard
            dashboardConfig={getDashboardConfig(dashboardConfig)}
            dashboardName="enhanced-view"
            version="7"
        />
    );
}

export default DashboardEnhancedView;
